import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { brandAssets, company, navigation } from "@/mocks/site";

export default function SiteHeader() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  const isActive = (href: string) =>
    href === "/" ? pathname === "/" : pathname.startsWith(href);

  return (
    <header className="sticky top-0 z-50 w-full">
      <div className="h-[3px] w-full bg-primary-500" />
      <div className="w-full border-b border-foreground-800 bg-foreground-950">
        <div className="mx-auto flex h-[70px] w-full max-w-shell items-center justify-between gap-4 px-4 md:h-[84px] md:px-6">
          <Link to="/" className="group flex items-center gap-3 pl-1">
            <img
              src={brandAssets.mark}
              alt={company.name}
              width={40}
              height={40}
              className="h-10 w-10 flex-none object-contain md:h-11 md:w-11"
            />
            <span className="flex flex-col">
              <span className="font-heading text-[15px] font-extrabold uppercase leading-none tracking-[0.16em] text-background-50 md:text-[18px]">
                Ulrich Arzt
              </span>
              <span className="mt-1.5 font-label text-[8px] uppercase leading-none tracking-[0.18em] text-background-400 md:text-[9.5px]">
                Präzisions-Mechanik · Sondermaschinen
              </span>
            </span>
          </Link>

          <nav className="hidden items-center gap-1 lg:flex">
            {navigation.map((item) => (
              <Link
                key={item.href}
                to={item.href}
                className={`relative flex h-[84px] items-center px-4 font-heading text-[12.5px] font-semibold uppercase tracking-[0.13em] transition-colors ${
                  isActive(item.href)
                    ? "text-background-50"
                    : "text-background-400 hover:text-background-100"
                }`}
              >
                {item.label}
                <span
                  className={`absolute bottom-0 left-4 right-4 h-[3px] bg-primary-500 transition-transform duration-300 ${
                    isActive(item.href) ? "scale-x-100" : "scale-x-0"
                  }`}
                />
              </Link>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <a
              href={`tel:${company.phoneHref}`}
              className="hidden items-center gap-2 font-label text-[12px] tracking-[0.06em] text-background-300 transition-colors hover:text-background-50 xl:flex"
            >
              <span className="flex h-7 w-7 items-center justify-center border border-foreground-700">
                <i className="ri-phone-line text-[13px] text-primary-400" />
              </span>
              {company.phone}
            </a>
            <Link
              to="/kontakt"
              className="hidden whitespace-nowrap bg-primary-500 px-5 py-3 font-heading text-[11.5px] font-bold uppercase tracking-[0.14em] text-background-50 transition-colors hover:bg-primary-600 sm:block"
            >
              Anfrage
            </Link>
            <button
              type="button"
              aria-label="Menü öffnen"
              aria-expanded={open}
              onClick={() => setOpen((prev) => !prev)}
              className="flex h-10 w-10 cursor-pointer items-center justify-center border border-foreground-700 text-background-100 transition-colors hover:border-primary-500 lg:hidden"
            >
              <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-[20px]`} />
            </button>
          </div>
        </div>

        {open && (
          <div className="border-t border-foreground-800 bg-foreground-950 lg:hidden">
            <nav className="mx-auto flex w-full max-w-shell flex-col px-4 py-2 md:px-6">
              {navigation.map((item) => (
                <Link
                  key={item.href}
                  to={item.href}
                  className={`flex items-center justify-between border-b border-foreground-800 py-4 font-heading text-[13px] font-semibold uppercase tracking-[0.13em] ${
                    isActive(item.href) ? "text-primary-300" : "text-background-200"
                  }`}
                >
                  {item.label}
                  <i className="ri-arrow-right-s-line text-[16px]" />
                </Link>
              ))}
              <a
                href={`tel:${company.phoneHref}`}
                className="flex items-center gap-2 py-4 font-label text-[12px] text-background-300"
              >
                <i className="ri-phone-line text-[14px] text-primary-400" />
                {company.phone}
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}